import { Checkbox as ChakraCheckbox } from '@chakra-ui/react'
import type { CheckboxProps } from '@chakra-ui/react'

export const Checkbox = (props: CheckboxProps) => {
  return <ChakraCheckbox {...props} />
}
